export default {"src":"/bnb/_next/static/media/hedera.889a22c6.svg","height":10,"width":10};